module.exports = __webpack_public_path__ + "static/media/365-term-project-topics.1c012190.pdf";